import { accordionClasses, paperClasses } from '@mui/material';
import { palette } from '../global/palette';
import { shape } from '../global/shape';
export const MuiAccordion = {
    MuiAccordion: {
        styleOverrides: {
            root: {
                boxShadow: 'none',
                borderRadius: shape.borderRadius,
                marginBottom: 4,
                '&:last-of-type': {
                    marginBottom: 0,
                },
                '&:before': {
                    display: 'none',
                },
                '&:hover': {
                    backgroundColor: palette.grey['200'],
                },
                [`&.${accordionClasses.expanded}`]: {
                    backgroundColor: palette.grey['200'],
                },
                [`&.${paperClasses.outlined}`]: {
                    border: `1px solid ${palette.grey['300']}`,
                    [`& .MuiAccordionDetails-root`]: {
                        padding: 24,
                        borderTop: `1px solid ${palette.grey['300']}`,
                        backgroundColor: palette.common.white,
                    },
                    [`&.${accordionClasses.expanded}`]: {
                        backgroundColor: palette.common.white,
                    },
                    [`& .MuiAccordionSummary-content`]: {
                        marginTop: 16,
                        marginBottom: 16,
                    },
                },
            },
        },
    },
};
